import React from 'react';
import { Helmet } from 'react-helmet';

const HeadManager = {
  Transforms: () => (
    <Helmet>
      {/* The "v2.x.x" doesn't work for us, we should use the correct version "v2.0.2" */}
      <script src="https://static.filestackapi.com/transforms-ui/2.0.2/transforms.umd.min.js" />
      <link rel="stylesheet" href="https://static.filestackapi.com/transforms-ui/2.x.x/transforms.css" />
    </Helmet>
  ),
  Quill: () => (
    <Helmet>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.6/quill.bubble.css" />
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.6/quill.core.css" />
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.6/quill.snow.css" />
    </Helmet>
  ),
};

export default HeadManager;
